import { render, staticRenderFns } from "./OrderAddressInformationEdit.vue?vue&type=template&id=adb6f2a8"
import script from "./OrderAddressInformationEdit.vue?vue&type=script&lang=js"
export * from "./OrderAddressInformationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports